import DialogsAPI from 'api/DialogsAPI';
import TrackingAPI from 'api/TrackingAPI';
import CommonHelper from 'helpers/CommonHelper';
import { useContinueDialogMediaMutation } from "services/api/dialogsApi";
import { useIsLegalMutation } from "services/api/generateScenarioApi";
import { errorAlert } from 'ui-kit/Alert';
import { getErrorMessage } from "utils/error";

import { scrollToBottom } from "../helpers";

const useSendDialogMessage = ({
  dialog,
  game,
  scenario,
  batches,
  setBatches,
  setNewMessageText,
  setTempText,
  setSending,
  setBadModalCountdownVisible,
  setCountdownSeconds,
  setIsContinueDialog,
  setTotalBatchesNumber,
  setCustomDialogsBatchesNumber,
  setUpdT,
  setChatMode,
  currentUser,
  openLegalDialogModal
}) => {

  const [isLegalRequest] = useIsLegalMutation();
  const [continueDialogMedia] = useContinueDialogMediaMutation();

  const shouldCheckIsLegal = currentUser?.shouldCheckIsLegal;

  const analyticsData = {
    scenario: game?.alias,
    config_name: scenario?.name,
    scenario_name: game?.name,
    dialogId: dialog?.id
  };

  const delay = (time) => {
    return new Promise(function (resolve) {
      setTimeout(resolve, time);
    });
  };

  const handleSendMessage = async (
    newMessageText,
    hasBadModel,
    checkIfBlockers,
    sending,
    isMediaMessage = false,
  ) => {
    if (checkIfBlockers('send_message')) return;
    if ((newMessageText === '' && !isMediaMessage) || sending) return;

    const oldNewMessageText = newMessageText;
    setNewMessageText('');
    setIsContinueDialog(true);
    setSending(true);

    if (shouldCheckIsLegal) {
      setBadModalCountdownVisible(false);
      setTempText(newMessageText);
      const { data: isLegal } = await isLegalRequest({ message: newMessageText });
      if (isLegal === false) {
        setBadModalCountdownVisible(true);
        openLegalDialogModal();
        setSending(false);
        setIsContinueDialog(false);
        setTempText(null);
        return;
      }
    }

    if (hasBadModel) {
      await delay(1000);
      const randomDelayValue = 15 + Math.round(5 * Math.random());
      setCountdownSeconds(randomDelayValue);
      setBadModalCountdownVisible(true);
      setTempText(newMessageText);
      setTimeout(scrollToBottom, 50);
      await delay(300 + randomDelayValue * 1000);

      TrackingAPI.trackEvent('priority_overlay_open', analyticsData);
    }

    setTimeout(scrollToBottom, 50);
    setTempText(newMessageText);

    let pld;
    try {
      if (isMediaMessage) {
        try {
          const { data } = await continueDialogMedia({ id: dialog?.id }).unwrap();
          TrackingAPI.trackEvent('custom_scenario_generate_image', analyticsData);
          pld = data;
        } catch (error) {
          const errorMessage = getErrorMessage(error);
          errorAlert(errorMessage);
        }
      } else {
        pld = await DialogsAPI.continueDialog(dialog?.id, newMessageText);
      }
      setTempText(undefined);
      setSending(false);
      setChatMode('chat');
    } catch (exc) {
      TrackingAPI.trackEvent('error_sending_message', analyticsData);

      if (exc?.response?.data?.message?.includes('restart')) {
        errorAlert('To continue, please restart the dialog');
      } else {
        errorAlert('Error sending message. Please try again');
      }
      setTempText(undefined);
      setSending(false);
      setNewMessageText(oldNewMessageText);
      return;
    }

    TrackingAPI.trackEvent('continueDialog', analyticsData);
    CommonHelper.yandexTrackFirstGameMessage(game);

    const newBatch = pld?.batch;
    const newBatches = [...batches, newBatch];
    setBatches(newBatches);
    setSending(false);
    scrollToBottom();

    DialogsAPI.getBatchesNumber().then((data) => {
      setTotalBatchesNumber(data.totalBatchesNumber);
      setCustomDialogsBatchesNumber(data.customDialogsUserBatchesNumber);
    });

    setTimeout(() => setUpdT(+new Date()), 100);
  };

  return { handleSendMessage };
};

export default useSendDialogMessage;